import actionTypes from './actionTypes';

const INITIAL_STATE = {
  getMyFavoritesLoading: false,
  getMyFavoritesFailed: false,
  getMyFavoritesReject: false,
  getMyFavoritesMessage: [],
  myFavoriteCafes: [],

  newFavoritesLoading: false,
  newFavoritesFailed: false,
  newFavoritesReject: false,
  newFavoritesMessage: [],
};

export default (state = INITIAL_STATE, action) => {
  switch (action.type) {
    case actionTypes.GET_MY_FAVORITES_LOADING: {
      return {
        ...state,
        getMyFavoritesLoading: true,
        getMyFavoritesFailed: false,
        getMyFavoritesReject: false,
        getMyFavoritesMessage: [],
        myFavoriteCafes: [],
      };
    }
    case actionTypes.GET_MY_FAVORITES_SUCCESS: {
      return {
        ...state,
        getMyFavoritesLoading: false,
        getMyFavoritesFailed: false,
        getMyFavoritesReject: false,
        getMyFavoritesMessage: [],
        myFavoriteCafes: action.payload.cafes,
      };
    }
    case actionTypes.GET_MY_FAVORITES_FAILED: {
      return {
        ...state,
        getMyFavoritesLoading: false,
        getMyFavoritesFailed: true,
        getMyFavoritesReject: false,
        getMyFavoritesMessage: [],
        myFavoriteCafes: [],
      };
    }
    case actionTypes.GET_MY_FAVORITES_REJECT: {
      const { message } = action.payload;
      return {
        ...state,
        getMyFavoritesLoading: false,
        getMyFavoritesFailed: false,
        getMyFavoritesReject: true,
        getMyFavoritesMessage: message,
        myFavoriteCafes: [],
      };
    }

    case actionTypes.NEW_FAVORITES_LOADING: {
      return {
        ...state,
        getMyFavoritesLoading: true,
        getMyFavoritesFailed: false,
        getMyFavoritesReject: false,
        getMyFavoritesMessage: [],
      };
    }
    case actionTypes.NEW_FAVORITES_SUCCESS: {
      return {
        ...state,
        newFavoritesLoading: false,
        newFavoritesFailed: false,
        newFavoritesReject: false,
        newFavoritesMessage: [],
        myFavoriteCafes: action.payload,
      };
    }
    case actionTypes.NEW_FAVORITES_FAILED: {
      return {
        ...state,
        newFavoritesLoading: false,
        newFavoritesFailed: true,
        newFavoritesReject: false,
        newFavoritesMessage: [],
      };
    }
    case actionTypes.NEW_FAVORITES_REJECT: {
      const { message } = action.payload;
      return {
        ...state,
        newFavoritesLoading: false,
        newFavoritesFailed: false,
        newFavoritesReject: true,
        newFavoritesMessage: message,
      };
    }

    default:
      return state;
  }
};
